import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UploadfileService {

  constructor(private http: HttpClient) { }
  httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
  };

  public uploadFile(files: File[], sfolder: string) {
    if (files.length != 0 ) {
      const formData = new FormData();
      for (var i = 0; i < files.length; i++) {
        let fileToUpload = <File>files[i];
        formData.append("file", fileToUpload, fileToUpload.name);
      }
      formData.append("sfolder", sfolder);
      return this.http.post("api/UploadFileSevice", formData, {
        reportProgress: true,
        observe: "events",
      });

    } else {
      return;
    }
  }

}
